import {
  CCShiftOptionType,
  PCCSchedulerControlFilters,
} from '@lp/features/Scheduler/SchedulerClinicalCoordinators/types';
import { dayConflictHighlightGetter, resourceConflictHighlightGetter } from '@lp/features/Scheduler/utils';
import { shiftTypeNames } from '@/constants/schedule.constants';
import { CCResourceType, CCShiftType, CSShiftType } from '@/api/apis/resources/schedule';
import { getNameValuesFromEnumNames } from '@/utils/helpers';
import { NameByValue } from '@/types';

export const singleCCShiftTypes = [CCShiftType.NoCall];

export const ccResourceTypeNames: Record<CCResourceType, string> = {
  [CCResourceType.TC1]: 'I',
  [CCResourceType.TC2]: 'II',
  [CCResourceType.TC3]: 'III',
};

export const ccShiftTypeNames: Record<CCShiftType, string> = {
  [CCShiftType.NoCall]: shiftTypeNames[CSShiftType.NoCall],
  [CCShiftType.OnCall]: shiftTypeNames[CSShiftType.OnCall],
  [CCShiftType.Sick]: shiftTypeNames[CSShiftType.Sick],
  [CCShiftType.Unavailable]: shiftTypeNames[CSShiftType.Unavailable],
  [CCShiftType.Vacation]: shiftTypeNames[CSShiftType.Vacation],
  [CCShiftType.WeekendOff]: shiftTypeNames[CSShiftType.WeekendOff],
};

export const ccShiftOptionTypeNames: Record<CCShiftOptionType, string> = {
  [CCShiftOptionType.OnCall]: shiftTypeNames[CSShiftType.OnCall],
  [CCShiftOptionType.OnDutyCall]: 'On Call (Duty)',
  [CCShiftOptionType.NoCall]: shiftTypeNames[CSShiftType.NoCall],
  [CCShiftOptionType.WeekendOff]: shiftTypeNames[CSShiftType.WeekendOff],
  [CCShiftOptionType.Sick]: shiftTypeNames[CSShiftType.Sick],
  [CCShiftOptionType.Vacation]: shiftTypeNames[CSShiftType.Vacation],
  [CCShiftOptionType.Unavailable]: shiftTypeNames[CSShiftType.Unavailable],
};

export const ccShiftOptionDropdownItems = [
  CCShiftOptionType.NoCall,
  CCShiftOptionType.OnCall,
  CCShiftOptionType.OnDutyCall,
  CCShiftOptionType.Unavailable,
  CCShiftOptionType.WeekendOff,
  CCShiftOptionType.Sick,
];

export const pccShiftOptionDropdownItems = [
  CCShiftOptionType.OnCall,
  CCShiftOptionType.OnDutyCall,
  CCShiftOptionType.NoCall,
  CCShiftOptionType.WeekendOff,
];

export const ccTotalsShiftTypeNames: Record<CCShiftType, string> = {
  ...shiftTypeNames,
  [CCShiftType.Unavailable]: 'N/A',
  [CSShiftType.WeekendOff]: 'Weekend',
};

export const ccTotalsShiftTypes = [
  CCShiftType.OnCall,
  CCShiftType.NoCall,
  CCShiftType.WeekendOff,
  CCShiftType.Vacation,
  CCShiftType.Sick,
  CCShiftType.Unavailable,
];

export const CC_SHIFT_TYPE_SELECT_LIST = getNameValuesFromEnumNames(ccShiftTypeNames);

export const CC_SHIFT_OPTION_DROPDOWN_LIST: NameByValue<CCShiftOptionType>[] = ccShiftOptionDropdownItems.map((so) => {
  return {
    value: so,
    name: ccShiftOptionTypeNames[so],
  };
});

export const PCC_SHIFT_OPTION_DROPDOWN_LIST: NameByValue<CCShiftOptionType>[] = pccShiftOptionDropdownItems.map(
  (so) => ({
    value: so,
    name: ccShiftOptionTypeNames[so],
  }),
);

export const ccConflictsDrawerData = [
  { label: 'BY USER', accessorKey: 'resourcesMessagesList', transformerFn: resourceConflictHighlightGetter } as const,
  {
    label: 'BY DAY',
    accessorKey: 'dayMessagesList',
    ignoreDay: true,
    transformerFn: dayConflictHighlightGetter,
  } as const,
];

export const initialPCCSchedulerControlFilters: PCCSchedulerControlFilters = {
  isPersonalView: true,
  resources: [],
};
